module.exports = __webpack_public_path__ + "media/images/badges/purebarre/PureBarre-6000-Classes-Active-26f99129ba0c8eea01ec67ff4c5a0ec0.png";